"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMortgagePrograms = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _calculateMonthlyPayment = require("../utils/calculateMonthlyPayment");
var _context = require("../../../context");
var _getMinInitialPayment = require("../utils/getMinInitialPayment");
var _utils = require("../../../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const useMortgagePrograms = _ref => {
  let {
    price,
    initialPayment,
    paymentPeriod,
    showEscrow
  } = _ref;
  const {
    programs,
    region
  } = (0, _context.useAppContext)();
  return (0, _react.useMemo)(() => {
    if (!programs.length || initialPayment >= price) {
      return [];
    }
    return programs.filter(_ref2 => {
      let {
        creditLimitMillions,
        termYears,
        minInitialPaymentPercent
      } = _ref2;
      const programPrice = creditLimitMillions[region] * 1000000;
      const minInitialPayment = (0, _getMinInitialPayment.getMinInitialPayment)(price, minInitialPaymentPercent);

      // Первоначальный взнос должен быть выше или такой же, как минимальный первоначальный взнос по программе
      const greaterThanMinInitialPayment = minInitialPayment <= initialPayment;
      // Сумма кредита должна быть ниже или такая же, как максимальная сумма кредита по программе
      const lessThanProgramMaxCredit = price - initialPayment <= programPrice;
      // Срок выплаты должен быть ниже или такой же, как максимальный срок выплаты по программе
      const lessThanProgramTermYears = paymentPeriod <= termYears;
      return greaterThanMinInitialPayment && lessThanProgramMaxCredit && lessThanProgramTermYears;
    }).map(program => _objectSpread(_objectSpread({}, program), {}, {
      creditLimitMillions: program.creditLimitMillions[region],
      payment: (0, _calculateMonthlyPayment.calculateMonthlyPayment)({
        price,
        initialPayment,
        rate: (0, _utils.getRate)({
          showEscrow,
          escrowRate: program.escrowRate,
          rate: program.rate
        }),
        years: paymentPeriod
      })
    }));
  }, [initialPayment, paymentPeriod, price, programs, region, showEscrow]);
};
exports.useMortgagePrograms = useMortgagePrograms;